/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Input, Button, Checkbox, Form } from "semantic-ui-react";
import {
  getBeneficiario,
  updateBeneficiatioState,
  resetBeneficiarioState,
} from "@store/actions/index";
import AjaxLoader from "./../shared/ajax_loader";
import CustomSnackbar from "./../shared/custom_snackbar";
import "@styles/consulta-pronto-socorro.css";
import ErrorMsgLabel from "../shared/errorMsgLabel";
import {
  dateDividers,
  getTodayDate,
  lastDayOfTheMonth,
  reverseMaskDate,
} from "@utils/date";
import m from "@utils/strings";

class FormAutorizacao extends Component {
  constructor(props) {
    super(props);

    this.novoAtendimento = false;

    this.state = {
      date: reverseMaskDate(getTodayDate()),
      numeroCarteira: "",
      recemNascido: false,
      success: false,
      error: false,
      showLoader: false,
      disabled: false,
      hasSubmitted: false,
      isDateValid: true,
      isNumeroCarteiraEmpty: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSetInitialFieldsState =
      this.handleSetInitialFieldsState.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
    this.props.setInitialFieldsState(this.handleSetInitialFieldsState);
    this.props.resetBeneficiarioState();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown(event) {
    switch (event.key) {
      case "Enter":
        if (!_.isEmpty(this.props.beneficiario)) {
          this.props.resetBeneficiarioState();
          this.handleSetInitialFieldsState();
          this.novoAtendimento = true;
        }
        break;
      default:
        break;
    }
  }

  handleChange = (event, { name, value }) => {
    if (_.isEmpty(value)) {
      this.setState({ isNumeroCarteiraEmpty: true });
    } else {
      this.setState({ isNumeroCarteiraEmpty: false });
    }

    value = value.replace(
      /([.*+?^=!:;>,<"'´`~&%$#@${}()|\[\]\\a-zA-Z\/\-\_])/g,
      ""
    );
    this.setState({
      [name]: value,
    });
  };

  handleCheckboxChange = () => {
    this.setState({ recemNascido: !this.state.recemNascido });
  };

  dateChange = (event, { name, value }) => {
    let temp = reverseMaskDate(value, dateDividers.DASH, dateDividers.BAR);
    let splitDate = temp.split("/");

    if (splitDate.length === 3) {
      if (parseInt(splitDate[1], 10) > 12) splitDate[1] = "1";

      if (
        splitDate[1].length > 0 &&
        parseInt(splitDate[0], 10) >
          lastDayOfTheMonth(parseInt(splitDate[1], 10))
      )
        splitDate[0] = "1";
      if (splitDate[2].length <= 4) {
        // value = splitDate[0] + "/" + splitDate[1] + "/" + splitDate[2];
        this.setState({ [name]: value });
      }
      if (
        splitDate[2].length === 4 &&
        new Date(`${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`) > new Date()
      ) {
        this.dataMaior();
        this.setState({ [name]: reverseMaskDate(getTodayDate()) });
      }
    } else if (splitDate.length > 3) {
    } else {
      this.setState({ [name]: value });
    }

    if (
      splitDate.length === 3 &&
      splitDate[0].length > 0 &&
      splitDate[1].length > 0 &&
      splitDate[2].length > 0 &&
      !this.isDateValid(splitDate)
    ) {
      this.setState({ isDateValid: false });
    } else {
      this.setState({ isDateValid: true });
    }
    this.props.dataAutorizacao(temp);
  };

  buildBeneficiarioParams = (date) => {
    const { willAuthorize, prestador } = this.props;

    console.log(prestador);
    const beneficiarioDTO = {
      CNPJPrestador: prestador.CPF_CNPJ,
      NomePrestador: prestador.Nome,
      NumeroCarteiraBeneficiario: this.state.numeroCarteira,
      NomeBeneficiario: "USUARIO GENERICO",
      CartaoNacionalSaude: "",
      DataAtual: date,
      HoraAtual: "",
      RecemNascido: this.state.recemNascido,
      RegistroANS: "",
      willAuthorize: willAuthorize,
      TipoAtendimento: "1",
    };
    return beneficiarioDTO;
  };

  isDateValid = (date) => {
    if (
      date.length != 3 ||
      date[1].length === 0 ||
      date[0].length === 0 ||
      date[2].length === 0
    )
      return false;
    if (
      new Date(`${date[1]}/${date[0]}/${date[2]}`).toString() === "Invalid Date"
    )
      return false;
    return true;
  };

  handleSubmit(event) {
    if (!this.state.hasSubmitted) {

      let date = reverseMaskDate(
        this.state.date,
        dateDividers.DASH,
        dateDividers.BAR
      ).split("/");
      if (!this.isDateValid(date) || date[2].length < 4) {
        this.setState({ isDateValid: false });
        return;
      } else {
        this.setState({ isDateValid: true });
      }

      if (_.isEmpty(this.state.numeroCarteira)) {
        this.setState({ isNumeroCarteiraEmpty: true });
        return;
      } else {
        this.setState({ isNumeroCarteiraEmpty: false });
      }

      if (
        _.isEmpty(this.props.beneficiario) &&
        !this.state.novoAtendimento &&
        !_.isEmpty(this.state.numeroCarteira)
      ) {
        const params = this.buildBeneficiarioParams(
          new Date(`${date[1]}/${date[0]}/${date[2]}`)
        );
        this.setState({
          showLoader: !this.state.showLoader,
          hasSubmitted: true
        });

        this.props.getBeneficiario(
          params,
          (result) => {
            this.setState({ showLoader: !this.state.showLoader });
            this.handleSubmitResult(result);
          },
          (error) => {
            this.setState({ showLoader: !this.state.showLoader });
            this.handleError(error);
          }
        );
      } else if (this.state.novoAtendimento) {
        this.novoAtendimento = false;
        this.handleSubmit(event);
      }
    }
  }

  handleSubmitResult = (result) => {
    this.props.updateBeneficiatioState(result);
    const {
      data: { SolicitacaoProcedimento },
    } = result;
    SolicitacaoProcedimento.senha !== null
      ? this.setState({ success: true, error: false, disabled: true })
      : this.setState({ error: true, success: false, disabled: true });

    if((result?.data?.SolicitacaoProcedimento?.DescricaoMotivoNegativa ?? "").length > 0)
      this.props.setMsgErrorApi(`${result?.data?.SolicitacaoProcedimento?.CodigoMotivoNegativa} - ${result?.data?.SolicitacaoProcedimento?.DescricaoMotivoNegativa}`);
  };

  handleError = (error) => {
    this.props.updateBeneficiatioState("API_ERROR");
    this.props.setMsgErrorApi(error);
    this.setState({ error: true, success: false, disabled: true });
    this.clickChild();
  };

  handleSetInitialFieldsState = () => {
    this.focus();
    this.setState({
      numeroCarteira: "",
      recemNascido: false,
      hasSubmitted: false,
      isDateValid: true,
      date: reverseMaskDate(getTodayDate()),
    });

    this.props.resetAllStates();
  };

  focus() {
    setTimeout(() => {
      if (this.textInput) this.textInput.focus();
    }, 1000);
  }

  render() {
    const { beneficiario } = this.props;

    const fieldClassName = `${
      this.state.success && beneficiario ? "success" : ""
    } 
            ${this.state.error && beneficiario ? "error" : ""}
            ${this.state.disabled && beneficiario ? "disabled" : ""}`;

    const numeroCarteiraClassName = `${
      this.state.success && beneficiario ? "success" : ""
    } 
            ${this.state.isNumeroCarteiraEmpty ? "error" : ""}
            ${this.state.disabled && beneficiario ? "disabled" : ""}`;

    const btnAutorizarClassName = `btn-default-cemig 
            ${this.state.disabled && beneficiario ? "disabled" : ""}`;

    const loader = this.state.showLoader ? <AjaxLoader /> : "";

    if (this.state.numeroCarteira.length > 17)
      this.setState({ numeroCarteira: this.state.numeroCarteira.slice(0, 17) });

    return (
      <div className={"form-autorizacao"}>
        {loader}
        <Form onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Field
              className={this.state.disabled && beneficiario ? "disabled" : ""}
              inline={true}
              width={10}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_DATA_ATENDIMENTO}
                </label>
              </div>
              <div className={"div-date-input"}>
                <Input
                  type="date"
                  style={{ width: 312 }}
                  name="date"
                  value={this.state.date}
                  iconPosition="left"
                  popupPosition="right center"
                  closable={true}
                  className={this.state.isDateValid ? "" : "error"}
                  onChange={this.dateChange}
                  disabled={this.state.disabled && beneficiario ? true : false}
                />
                <ErrorMsgLabel
                  boolean={!this.state.isDateValid}
                  message={
                    m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_DATA_INVALIDA
                  }
                />
              </div>
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field className={numeroCarteiraClassName} inline={true}>
              <div className={"div-separador-top"} style={{ width: 312 }}>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_NUMERO_CARTEIRA}
                </label>
              </div>
              <Input
                style={{ width: 312 }}
                disabled={this.state.disabled && beneficiario ? true : false}
                name="numeroCarteira"
                icon="id card"
                autoFocus
                iconPosition="left"
                value={this.state.numeroCarteira}
                onChange={this.handleChange}
                ref={(input) => {
                  this.textInput = input;
                }}
              />
              <ErrorMsgLabel
                boolean={this.state.isNumeroCarteiraEmpty}
                message={
                  m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_CAMPO_OBRIGATORIO
                }
              />
            </Form.Field>
            <Form.Field className={fieldClassName} inline={true} width={10}>
              <Checkbox
                name="recemNascido"
                label={m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_RECEM_NASCIDO}
                type="checkbox"
                style={{ marginTop: 30, fontFamily: "Work Sans" }}
                disabled={this.state.disabled && beneficiario ? true : false}
                checked={this.state.recemNascido}
                onChange={this.handleCheckboxChange}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field className={fieldClassName} inline={true} width={10}>
              <Button
                type="submit"
                className={btnAutorizarClassName}
                disabled={this.state.disabled && beneficiario ? true : false}
              >
                {m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_AUTORIZAR} (ENTER)
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <CustomSnackbar
          setClick={(click) => (this.clickChild = click)}
          variant="error"
          duration={8000}
          content={
            m.TELA_CONSULTA_PRONTO_SOCORRO.NOTIFICACAO_ERRO_COMUNICACAO_SERVICO
          }
        />
        <CustomSnackbar
          setClick={(click) => (this.dataMaior = click)}
          variant="warning"
          duration={2000}
          content={m.TELA_CONSULTA_PRONTO_SOCORRO.NOTIFICACAO_DATA_MENOR}
        />
      </div>
    );
  }
}

export default connect(null, {
  getBeneficiario,
  updateBeneficiatioState,
  resetBeneficiarioState,
})(FormAutorizacao);
